export const EXCEL_TABLE_VALUE = {
  senderMobileNumber: 'booking.fieldLabel.senderMobileNumber',
  senderLocationDetails: 'history.table.senderLocationDetailsOptional',
  receiverLocationDetails: 'history.table.receiverLocationDetailsOptional',
  serviceType: 'booking.fieldLabel.serviceType',
  paymentMethods: 'booking.fieldLabel.paymentMethod',
  senderName: 'booking.fieldLabel.senderName',
  senderAddress: 'booking.fieldLabel.senderAddress',
  recipient: 'booking.common.recipient',
  codItem: 'booking.common.codItem',
  promo: 'booking.fieldLabel.promo',
  deliveryInstruction: 'history.table.deliveryInstruction',
  additionalID: 'history.table.additionalID',
  recipientName: 'booking.fieldLabel.recipientName',
  recipientMobileNumber: 'booking.fieldLabel.recipientMobileNumber',
  recipientAddress: 'booking.fieldLabel.recipientAddress',
  referenceCode: 'booking.fieldLabel.referenceCode',
  weight: 'booking.fieldLabel.weight',
  parcelCategory: 'booking.fieldLabel.parcelCategory',
  vehicleType: 'booking.fieldLabel.vehicleType',
  batchReference: 'booking.fieldLabel.batchReference',
  sequenceNumber: 'booking.fieldLabel.sequenceNumber',
  itemNote: 'booking.fieldLabel.itemNote',
};

export const HIDDEN_DATA_COLUMN = {
  CITY_ID: 'AY1',
  SERVICE_TYPE: 'AZ150',
  PARCEL_CATEGORY: 'AX150',
  VEHICLE_TYPE: 'AW150',
};

export const V2_EXCEL_TABLE_CONTENT_COLS = [...'ABCDEFGHIJKLMNOPQRSTU'];

export const V1_EXCEL_TABLE_CONTENT_COLS = [...'ABCDEFGHIJKLMN'];
